import React, { useEffect, useState } from "react";
import "./index.css";
import GenerativeIaEvaluationService from "../../../services/GenerativeIaEvaluationService/GenerativeIaEvaluationService";
import LcLoading from "../LcLoading";
import AlertNotification, { AlertColor } from "../../Dialog/AlertNotification";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import LcAccordion from "../LcAccordion";
import Modal from "../../Dialog/Modal";
import ContentEditable from "react-contenteditable";
import HHContentAI from "../HHContentAI";

interface Props {
    originalText: string;
    visible: boolean;
    handleVisible: Function;
    setText: Function;
    user: any;
    solicitation: any;
    title?: string;
    conclusion?: Boolean;
    style?: any;
    modal?: boolean;
    withOriginalText?: boolean;
    summarization?: boolean;
    instructionType?: number;
    auxProps?: { [key: string]: any }; // Add this line to include auxProps
}

const HHCommentAI: React.FC<Props> = (props) => {
    const handleClickAway = (event) => {
        if (props.visible && props.handleVisible && !event.target.className.includes('icon')) {
            props.handleVisible(false);
        }
    };

    return (
        <>
            {
                props.modal
                    ? <ClickAwayListener onClickAway={handleClickAway}>
                        <Modal close={() => props.handleVisible(false)} visible={props.visible} title={props.title}>
                            <HHContentAI
                                summarization={props.summarization}
                                withOriginalText={props.withOriginalText}
                                originalText={props.originalText}
                                visible={props.visible}
                                handleVisible={props.handleVisible}
                                setText={props.setText}
                                user={props.user}
                                solicitation={props.solicitation}
                                conclusion={props.conclusion}
                                instructionType={props.instructionType}
                                auxProps={props.auxProps} // Pass auxProps to HHContentAI
                            />
                        </Modal>
                    </ClickAwayListener>
                    : <HHContentAI
                        summarization={props.summarization}
                        withOriginalText={props.withOriginalText}
                        originalText={props.originalText}
                        visible={props.visible}
                        handleVisible={props.handleVisible}
                        setText={props.setText}
                        user={props.user}
                        solicitation={props.solicitation}
                        conclusion={props.conclusion}
                        instructionType={props.instructionType}
                        auxProps={props.auxProps} // Pass auxProps to HHContentAI
                    />
            }
        </>
    )
}

export default HHCommentAI;